import { ProviderRecord } from "models/view-models/providers/provider-record";
import { PROVIDER_STATUS_VALUES } from "../components/report-provider-status/report-provider-status";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

interface ReportAenProviderInvoiceState {
    aenProviders: ProviderRecord[];
    aenProviderStatusActive: string;
    dateRangeStart: Date | null;
    dateRangeEnd: Date | null;
}

type ReducerActions =
    | { type: "updateProviders"; aenProviders: ProviderRecord[] }
    | { type: "dateRange"; dateRangeStart: Date | null; dateRangeEnd: Date | null }
    | { type: "aenProviderStatusActive"; aenProviderStatusActive: string };

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Reducer
// -------------------------------------------------------------------------------------------------

const initialState: ReportAenProviderInvoiceState = {
    aenProviders: [],
    aenProviderStatusActive: PROVIDER_STATUS_VALUES.ACTIVE_AND_INACTIVE,
    dateRangeStart: null,
    dateRangeEnd: null,
};

const validate = (): boolean => {
    return true;
};

const reducer = (state: ReportAenProviderInvoiceState, action: ReducerActions): ReportAenProviderInvoiceState => {
    switch (action.type) {
        case "updateProviders":
            const { aenProviders } = action;

            return { ...state, aenProviders };

        case "dateRange":
            const { dateRangeStart, dateRangeEnd } = action;

            return {
                ...state,
                dateRangeStart,
                dateRangeEnd,
            };
        case "aenProviderStatusActive":
            console.log("reducer: aenProviderStatusActive", action.aenProviderStatusActive);
            return {
                ...state,
                aenProviderStatusActive: action.aenProviderStatusActive,
            };

        default:
            throw new Error();
    }
};

const initializer =
    () =>
    (initialState: ReportAenProviderInvoiceState): ReportAenProviderInvoiceState => {
        return initialState;
    };

// #endregion Reducer
// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------
export { initialState, initializer, reducer, validate };
export type { ReportAenProviderInvoiceState };

// #endregion Exports
